import { render, staticRenderFns } from "./MyOrderDetailList.vue?vue&type=template&id=3069d368&scoped=true&"
import script from "./MyOrderDetailList.vue?vue&type=script&lang=js&"
export * from "./MyOrderDetailList.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderDetailList.vue?vue&type=style&index=0&id=3069d368&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3069d368",
  null
  
)

export default component.exports